import { Component } from '@angular/core';
import { FeedbackPlatformApplicationUserEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Application Users') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformapplicationuser-form',
    templateUrl: './feedbackplatformapplicationuser.form.component.html'
})
export class FeedbackPlatformApplicationUserFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformApplicationUserEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

